import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [
			{
				"type": "shape",
				"id": "PJUeeG-9S4",
				"width": 624.6,
				"height": 284.93,
				"left": 302.4749999999999,
				"top": 138.78500000000003,
				"viewBox": [
					200,
					200
				],
				"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
				"fill": "#bd150a",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#254061",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Calibri;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false
			},
			{
				"type": "text",
				"id": "Saqv_jqMc8",
				"width": 319.71,
				"height": 76.09375,
				"left": 454.92,
				"top": 198.42,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"\"><em><strong><span style=\"font-size: 55.1px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">PART.${serial}</span></span></span></strong></em></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "o5XL584mbB",
				"width": 249.63,
				"height": 48,
				"left": 454.92,
				"top": 301.29,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": `<p style=\"text-align: center;\"><strong><span style=\"font-size: 28px;\"><span style=\"color: #ffffff;\">${title}</span></span></strong></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	}
}